/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询订单的详细数据
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class EsParams {
  constructor(public orderId: string) {}
}

export default async function (
  params: EsParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/es`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
